import resetRowIndexes from "./reset-row-indexes"
import deleteRow from './delete-row'

export default function (e) {
	e.stopPropagation()
	e.preventDefault()

	const repeater = e.target.closest('.repeater-container')
	const rowTemplate = repeater.querySelector('.template .row')

	const newRow = rowTemplate.cloneNode(true)

	resetInputValues( newRow )

	e.target.closest('.button-container').before(newRow)

	resetRowIndexes(repeater.querySelector('.rows'))

	newRow.querySelector('.delete-row').addEventListener('click', deleteRow)
}

function resetInputValues( row ) {
	row.querySelectorAll('input, textarea, select').forEach(input => {
		input.value = ''

		if ( input.checked ) {
			input.checked = false
		}

		input.disabled = false
	})

	return row
}
